import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentSourceService {
  cards: Observable<any>;

  constructor(
    private afs: AngularFirestore
  ) {
    if (localStorage.getItem('user') != null) {
      const userId = JSON.parse(localStorage.getItem('user')).uid;
      this.cards = this.afs.doc(`users/${userId}`).collection('card-source').valueChanges();
    }
  }

  setCards(uid: string): void {
    this.cards = this.getCards(uid).pipe();
  }

  getCards(uid: string) {
    return this.afs.doc(`users/${uid}`).collection('card-source',
      ref => ref.where('isDeleted', '==', false))
      .valueChanges();
  }
}
